module.exports = __webpack_public_path__ + "img/wall_03.png";